export const storeAudioEnabled = audioEnabled => ({
  type: 'STORE_AUDIO_ENABLED',
  audioEnabled
});

export const storeTranscriptEnabled = transcriptEnabled => ({
  type: 'STORE_TRANSCRIPT_ENABLED',
  transcriptEnabled
});

const initialState = {
  audioEnabled: true,
  transcriptEnabled: false
};

export default function audioReducer(state = initialState, action) {
  switch (action.type) {
    case 'STORE_AUDIO_ENABLED': {
      return {
        ...state,
        audioEnabled: action.audioEnabled
      };
    }
    case 'STORE_TRANSCRIPT_ENABLED': {
      return {
        ...state,
        transcriptEnabled: action.transcriptEnabled
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ../core/src/store/audio.js